<script setup>
// Aceleres — navegação principal da Caixa de Entrada.
import { computed, ref } from 'vue';
import InboxUnreadTooltip from './InboxUnreadTooltip.vue';
import UnreadCountBadge from './UnreadCountBadge.vue';
const props = defineProps({
  modelValue: { type: String, default: 'notifications' },
  notificationsCount: { type: Number, default: 0 },
  emailsCount: { type: Number, default: 0 },
  unreadTooltipTitle: { type: String, default: '' },
  unreadTooltipLines: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:modelValue']);
const notificationsButton = ref(null);
const isNotificationsHovered = ref(false);
const isNotificationsFocused = ref(false);
const isTooltipVisible = computed(
  () => isNotificationsHovered.value || isNotificationsFocused.value
);

const setTabButton = (element, key) => {
  if (key === 'notifications') notificationsButton.value = element;
};

const hideTooltip = () => {
  isNotificationsHovered.value = false;
  isNotificationsFocused.value = false;
};

const tabs = [
  {
    key: 'notifications',
    label: 'INBOX.TABS.NOTIFICATIONS',
    count: 'notificationsCount',
  },
  { key: 'emails', label: 'INBOX.TABS.EMAILS', count: 'emailsCount' },
];

const select = key => {
  if (key !== props.modelValue) emit('update:modelValue', key);
};
</script>

<template>
  <div
    class="flex gap-5 border-b border-n-weak px-4 md:px-5"
    role="tablist"
    :aria-label="$t('INBOX.LIST.TITLE')"
  >
    <button
      v-for="tab in tabs"
      :key="tab.key"
      :ref="element => setTabButton(element, tab.key)"
      type="button"
      role="tab"
      :aria-selected="modelValue === tab.key"
      :aria-describedby="
        tab.key === 'notifications'
          ? 'inbox-notifications-tab-tooltip'
          : undefined
      "
      class="relative inline-flex min-h-11 items-center gap-2 border-b-2 px-1 text-[13px] font-medium transition-colors whitespace-nowrap"
      :class="
        modelValue === tab.key
          ? 'rounded-t-lg border-[#15803D] bg-[#E8F6EC] text-[#14532D]'
          : 'border-transparent text-n-slate-10 hover:text-n-slate-12'
      "
      @mouseenter="isNotificationsHovered = tab.key === 'notifications'"
      @mouseleave="isNotificationsHovered = false"
      @focus="isNotificationsFocused = tab.key === 'notifications'"
      @blur="isNotificationsFocused = false"
      @keydown.esc="hideTooltip"
      @click="select(tab.key)"
    >
      <span>{{ $t(tab.label) }}</span>
      <UnreadCountBadge :count="props[tab.count]" />
    </button>
    <InboxUnreadTooltip
      id="inbox-notifications-tab-tooltip"
      placement="below"
      :anchor="notificationsButton"
      :title="unreadTooltipTitle"
      :lines="unreadTooltipLines"
      :visible="isTooltipVisible"
    />
  </div>
</template>
